import { render } from "./GroupReport.vue?vue&type=template&id=6fdb3804&scoped=true"
import script from "./GroupReport.vue?vue&type=script&lang=js"
export * from "./GroupReport.vue?vue&type=script&lang=js"

import "./GroupReport.vue?vue&type=style&index=0&id=6fdb3804&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdb3804"]])

export default __exports__